import React from 'react'
import { StyleSheet, Text } from 'react-native'
import { colors } from '@lib/colors'

interface Props {
  children: string
}

export default function ({ children }: Props) {
  return (

   <Text style={styles.stepDescription}>
     { children }
   </Text>
  )
}

const styles = StyleSheet.create({
  stepDescription: {
    color: colors.gray['600'],
    lineHeight: 20,
    marginTop: 5,
    textAlign: 'center',
    fontSize: 14,
  },
})
